import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPinFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2C7.59 2 4 5.57 4 9.95c0 4.12 6.54 10.98 7.28 11.75.19.19.45.3.72.3s.53-.11.72-.3c.75-.77 7.28-7.62 7.28-11.75C20 5.57 16.41 2 12 2m0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5"
    />
  </svg>
);
export default SvgMapPinFilled;
